import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BRAND_GREEN, BRAND_GREEN_LIGHT } from '../theme/sucronTheme';


const PrivacySettingsPage = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({
    researchConsent: false,
    dataCollectionConsent: true,
    marketingConsent: false
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState('');

  useEffect(() => {
    loadPrivacySettings();
  }, []);

  const loadPrivacySettings = async () => {
    try {
      // TODO: Implementar chamada real à API
      // const response = await fetch(`http://localhost:5000/api/user/privacy-settings`, {
      //   headers: { 'Authorization': `Bearer ${user.token}` }
      // });
      // const data = await response.json();
      
      // Simulação temporária
      setTimeout(() => {
        setSettings({
          researchConsent: user?.researchConsent || false,
          dataCollectionConsent: true,
          marketingConsent: false
        });
        setLoading(false);
      }, 500);
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
      setLoading(false);
    }
  };

  const handleToggle = (setting) => {
    if (setting === 'dataCollectionConsent') {
      setMessage({
        type: 'error',
        text: 'O consentimento básico de coleta de dados é necessário para usar a plataforma.'
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 5000);
      return;
    }

    setSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
  };

  const saveSettings = async () => {
    setSaving(true);
    try {
      // TODO: Implementar chamada real à API
      // await fetch(`http://localhost:5000/api/user/privacy-settings`, {
      //   method: 'PATCH',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': `Bearer ${user.token}`
      //   },
      //   body: JSON.stringify(settings)
      // });

      // Simulação temporária
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setMessage({
        type: 'success',
        text: 'Configurações de privacidade atualizadas com sucesso!'
      });
      
      setTimeout(() => setMessage({ type: '', text: '' }), 5000);
    } catch (error) {
      console.error('Erro ao salvar configurações:', error);
      setMessage({
        type: 'error',
        text: 'Erro ao salvar configurações. Tente novamente.'
      });
    } finally {
      setSaving(false);
    }
  };

  const exportData = async () => {
    try {
      // TODO: Implementar chamada real à API
      // const response = await fetch(`http://localhost:5000/api/user/data-export`, {
      //   headers: { 'Authorization': `Bearer ${user.token}` }
      // });
      // const blob = await response.blob();
      // const url = window.URL.createObjectURL(blob);
      // const a = document.createElement('a');
      // a.href = url;
      // a.download = 'meus-dados-arenastats.json';
      // a.click();

      // Simulação temporária
      const mockData = {
        user: {
          name: user?.name || 'Usuário',
          email: user?.email || 'usuario@exemplo.com',
          createdAt: new Date().toISOString()
        },
        preferences: {
          favoriteTeams: [],
          favoriteLeagues: [],
          favoriteCompetitions: []
        },
        privacySettings: settings,
        exportDate: new Date().toISOString()
      };

      const blob = new Blob([JSON.stringify(mockData, null, 2)], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'meus-dados-arenastats.json';
      a.click();
      window.URL.revokeObjectURL(url);

      setMessage({
        type: 'success',
        text: 'Dados exportados com sucesso! Verifique seus downloads.'
      });
      setTimeout(() => setMessage({ type: '', text: '' }), 5000);
    } catch (error) {
      console.error('Erro ao exportar dados:', error);
      setMessage({
        type: 'error',
        text: 'Erro ao exportar dados. Tente novamente.'
      });
    }
  };

  const handleDeleteAccount = async () => {
    if (deleteConfirmation !== 'EXCLUIR') {
      setMessage({
        type: 'error',
        text: 'Digite "EXCLUIR" em letras maiúsculas para confirmar.'
      });
      return;
    }

    try {
      // TODO: Implementar chamada real à API
      // await fetch(`http://localhost:5000/api/user/account`, {
      //   method: 'DELETE',
      //   headers: { 'Authorization': `Bearer ${user.token}` }
      // });

      setMessage({
        type: 'success',
        text: 'Solicitação de exclusão enviada. Você receberá um email de confirmação.'
      });
      
      setTimeout(() => {
        // logout();
        // navigate('/');
      }, 3000);
    } catch (error) {
      console.error('Erro ao solicitar exclusão:', error);
      setMessage({
        type: 'error',
        text: 'Erro ao processar solicitação. Tente novamente.'
      });
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto" style={{ borderColor: BRAND_GREEN }}></div>
          <p className="mt-4 text-gray-600">Carregando configurações...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Configurações de Privacidade</h1>
          <p className="mt-2 text-gray-600">
            Gerencie seus dados pessoais e consentimentos conforme a LGPD
          </p>
        </div>

        {/* Mensagens de feedback */}
        {message.text && (
          <div className={`mb-6 p-4 rounded-md ${
            message.type === 'success' ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'
          }`}>
            <p className={`text-sm ${message.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
              {message.text}
            </p>
          </div>
        )}

        {/* Seção de Consentimentos */}
        <div className="bg-white shadow rounded-lg mb-6">
          <div className="px-6 py-5 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">Consentimentos</h2>
            <p className="mt-1 text-sm text-gray-600">
              Controle como seus dados são utilizados
            </p>
          </div>
          
          <div className="px-6 py-6 space-y-6">
            {/* Coleta básica */}
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-base font-medium text-gray-900">Coleta básica de dados</h3>
                <p className="mt-1 text-sm text-gray-600">
                  Necessário para o funcionamento da plataforma (nome, email, preferências).
                  Este consentimento não pode ser revogado enquanto você mantiver sua conta ativa.
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <button
                  disabled
                  className="relative inline-flex h-6 w-11 flex-shrink-0 cursor-not-allowed rounded-full 
                           border-2 border-transparent transition-colors duration-200 ease-in-out 
                           focus:outline-none bg-opacity-50"
                  style={{ backgroundColor: BRAND_GREEN }}
                >
                  <span className="translate-x-5 inline-block h-5 w-5 transform rounded-full bg-white shadow"></span>
                </button>
              </div>
            </div>

            {/* Pesquisa científica */}
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-base font-medium text-gray-900">Uso para pesquisa científica</h3>
                <p className="mt-1 text-sm text-gray-600">
                  Autoriza o uso <strong>anonimizado</strong> dos seus dados de preferências esportivas 
                  em estudos acadêmicos. Nenhuma informação pessoal identificável será compartilhada.
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <button
                  onClick={() => handleToggle('researchConsent')}
                  className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full 
                           border-2 border-transparent transition-colors duration-200 ease-in-out 
                           focus:outline-none ${settings.researchConsent ? 'bg-opacity-100' : 'bg-gray-200'}`}
                  style={{ backgroundColor: settings.researchConsent ? BRAND_GREEN : undefined }}
                >
                  <span className={`${settings.researchConsent ? 'translate-x-5' : 'translate-x-0'} 
                                 inline-block h-5 w-5 transform rounded-full bg-white shadow 
                                 transition duration-200 ease-in-out`}></span>
                </button>
              </div>
            </div>

            {/* Marketing */}
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-base font-medium text-gray-900">Comunicações de marketing</h3>
                <p className="mt-1 text-sm text-gray-600">
                  Receber emails sobre novos recursos, estatísticas especiais e promoções da ArenaStats.
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <button
                  onClick={() => handleToggle('marketingConsent')}
                  className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full 
                           border-2 border-transparent transition-colors duration-200 ease-in-out 
                           focus:outline-none ${settings.marketingConsent ? 'bg-opacity-100' : 'bg-gray-200'}`}
                  style={{ backgroundColor: settings.marketingConsent ? BRAND_GREEN : undefined }}
                >
                  <span className={`${settings.marketingConsent ? 'translate-x-5' : 'translate-x-0'} 
                                 inline-block h-5 w-5 transform rounded-full bg-white shadow 
                                 transition duration-200 ease-in-out`}></span>
                </button>
              </div>
            </div>

            {/* Botão de salvar */}
            <div className="pt-4 border-t border-gray-200">
              <button
                onClick={saveSettings}
                disabled={saving}
                className="px-6 py-2 text-white rounded-md font-medium hover:opacity-90 
                         transition-opacity disabled:opacity-50"
                style={{ backgroundColor: BRAND_GREEN }}
              >
                {saving ? 'Salvando...' : 'Salvar Configurações'}
              </button>
            </div>
          </div>
        </div>

        {/* Seção de Direitos LGPD */}
        <div className="bg-white shadow rounded-lg mb-6">
          <div className="px-6 py-5 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">Seus Direitos (LGPD)</h2>
            <p className="mt-1 text-sm text-gray-600">
              Exerça seus direitos sobre seus dados pessoais
            </p>
          </div>
          
          <div className="px-6 py-6 space-y-4">
            {/* Exportar dados */}
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <div className="flex-1">
                <h3 className="text-base font-medium text-gray-900">Exportar meus dados</h3>
                <p className="mt-1 text-sm text-gray-600">
                  Baixe uma cópia de todos os seus dados em formato JSON (portabilidade de dados - Art. 18, V da LGPD)
                </p>
              </div>
              <button
                onClick={exportData}
                className="ml-4 px-4 py-2 border-2 rounded-md font-medium hover:bg-gray-50 transition"
                style={{ borderColor: BRAND_GREEN, color: BRAND_GREEN }}
              >
                Exportar
              </button>
            </div>

            {/* Visualizar dados */}
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <div className="flex-1">
                <h3 className="text-base font-medium text-gray-900">Visualizar dados coletados</h3>
                <p className="mt-1 text-sm text-gray-600">
                  Veja quais dados pessoais temos sobre você (confirmação da existência de tratamento - Art. 18, I da LGPD)
                </p>
              </div>
              <Link
                to="/perfil/dados"
                className="ml-4 px-4 py-2 border-2 rounded-md font-medium hover:bg-gray-50 transition"
                style={{ borderColor: BRAND_GREEN, color: BRAND_GREEN }}
              >
                Visualizar
              </Link>
            </div>

            {/* Corrigir dados */}
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <div className="flex-1">
                <h3 className="text-base font-medium text-gray-900">Corrigir dados</h3>
                <p className="mt-1 text-sm text-gray-600">
                  Atualize informações incorretas ou desatualizadas (correção de dados - Art. 18, III da LGPD)
                </p>
              </div>
              <Link
                to="/perfil/editar"
                className="ml-4 px-4 py-2 border-2 rounded-md font-medium hover:bg-gray-50 transition"
                style={{ borderColor: BRAND_GREEN, color: BRAND_GREEN }}
              >
                Editar Perfil
              </Link>
            </div>

            {/* Contatar DPO */}
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <div className="flex-1">
                <h3 className="text-base font-medium text-gray-900">Falar com o Encarregado de Dados (DPO)</h3>
                <p className="mt-1 text-sm text-gray-600">
                  Entre em contato para dúvidas sobre privacidade, LGPD ou tratamento de dados
                </p>
              </div>
              <Link
                to="/contato"
                className="ml-4 px-4 py-2 border-2 rounded-md font-medium hover:bg-gray-50 transition"
                style={{ borderColor: BRAND_GREEN, color: BRAND_GREEN }}
              >
                Contatar
              </Link>
            </div>
          </div>
        </div>

        {/* Zona de perigo */}
        <div className="bg-white shadow rounded-lg border-2 border-red-200">
          <div className="px-6 py-5 border-b border-red-200 bg-red-50">
            <h2 className="text-xl font-semibold text-red-900">Zona de Perigo</h2>
            <p className="mt-1 text-sm text-red-600">
              Ações irreversíveis relacionadas aos seus dados
            </p>
          </div>
          
          <div className="px-6 py-6">
            <div className="p-4 bg-red-50 rounded-lg">
              <h3 className="text-base font-medium text-gray-900">Excluir minha conta</h3>
              <p className="mt-1 text-sm text-gray-600 mb-4">
                Esta ação é <strong>permanente e irreversível</strong>. Todos os seus dados serão 
                excluídos de nossos sistemas (eliminação de dados - Art. 18, VI da LGPD). 
                Você receberá um email de confirmação antes da exclusão definitiva.
              </p>
              
              {!showDeleteModal ? (
                <button
                  onClick={() => setShowDeleteModal(true)}
                  className="px-4 py-2 bg-red-600 text-white rounded-md font-medium hover:bg-red-700 transition"
                >
                  Solicitar Exclusão de Conta
                </button>
              ) : (
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Digite "EXCLUIR" em letras maiúsculas para confirmar:
                    </label>
                    <input
                      type="text"
                      value={deleteConfirmation}
                      onChange={(e) => setDeleteConfirmation(e.target.value)}
                      className="block w-full px-3 py-2 border border-gray-300 rounded-md 
                               focus:outline-none focus:ring-2 focus:ring-red-500"
                      placeholder="Digite EXCLUIR"
                    />
                  </div>
                  <div className="flex space-x-3">
                    <button
                      onClick={handleDeleteAccount}
                      disabled={deleteConfirmation !== 'EXCLUIR'}
                      className="px-4 py-2 bg-red-600 text-white rounded-md font-medium 
                               hover:bg-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Confirmar Exclusão
                    </button>
                    <button
                      onClick={() => {
                        setShowDeleteModal(false);
                        setDeleteConfirmation('');
                      }}
                      className="px-4 py-2 border border-gray-300 rounded-md font-medium 
                               hover:bg-gray-50 transition"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Links úteis */}
        <div className="mt-8 text-center text-sm text-gray-600">
          <p>
            Dúvidas sobre privacidade?{' '}
            <Link to="/privacidade" className="font-medium hover:underline" style={{ color: BRAND_GREEN }}>
              Leia nossa Política de Privacidade
            </Link>
            {' ou '}
            <Link to="/contato" className="font-medium hover:underline" style={{ color: BRAND_GREEN }}>
              entre em contato
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettingsPage;
